import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[workUiAlertDialogs]',
  standalone: true,
})
export class AlertDialogsDirective {
  viewContainerRef = inject(ViewContainerRef);
}
